var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlazaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.316,
    height: 93.48,
    fill: "#104864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118 -1694.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(118 1694.998)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.796 1745.757)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.332,111.93a1.217,1.217,0,0,0,.359-.867v-3.139a7.514,7.514,0,0,0-7.506-7.505,5.054,5.054,0,0,1-5.052-5.052V81.24a1.217,1.217,0,0,0-.359-.867,1.234,1.234,0,0,0-.867-.359H14.946a1.227,1.227,0,0,0-1.227,1.226V95.367a7.464,7.464,0,0,0,1.54,4.5l.425.552h-.395v18.149h2.453V102.022l.482.214a7.385,7.385,0,0,0,3,.636,5.052,5.052,0,0,1,5.051,5.052v3.139a1.218,1.218,0,0,0,.36.867,1.234,1.234,0,0,0,.868.359h1.912v6.279h2.453v-6.279H56.1v6.279h2.453v-6.279h1.912a1.234,1.234,0,0,0,.868-.359M16.172,82.467H46.681v5.395H16.172Zm5.052,17.952a5.053,5.053,0,0,1-5.052-5.052V90.315H46.681v5.052a7.478,7.478,0,0,0,1.539,4.5l.424.552Zm38.014,9.417H28.729v-1.912a7.457,7.457,0,0,0-1.54-4.5l-.425-.553H54.186a5.053,5.053,0,0,1,5.052,5.052Z",
    transform: "translate(-4.302 -25.088)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.749,71.043l1.21-4.842-2.379-.6-1.315,5.258-8.751,2.5V62.031L71.82,62A13.8,13.8,0,0,0,84.071,48.3V13.773A13.783,13.783,0,0,0,57.118,9.721l-.163.527-.4-.378a7.425,7.425,0,0,0-5.1-2.032h0a7.158,7.158,0,0,0-2.336.391l-.239.082-.15-.2a12.2,12.2,0,0,0-21.959,5.861l-.042.366-.362-.067a9,9,0,0,0-1.593-.151,8.709,8.709,0,0,0-3.388.683l-.216.091L21,14.72A12.206,12.206,0,0,0,0,23.19a1.216,1.216,0,0,0,.359.867,1.233,1.233,0,0,0,.867.359H32.618a1.233,1.233,0,0,0,.868-.359,1.216,1.216,0,0,0,.359-.867,9.014,9.014,0,0,0-2.328-6.048L31,16.568H56.507V48.3A13.8,13.8,0,0,0,68.759,62l.3.034v6.436l-5.847-2.339L62.3,68.406l6.76,2.7V93.479h2.453V75.912l9.733-2.78,4.021,1.341.776-2.331ZM31.182,21.534l.112.43H2.518l.067-.4A9.762,9.762,0,0,1,19.892,17.18a1.226,1.226,0,0,0,1.58.305,6.527,6.527,0,0,1,3.295-.917,6.636,6.636,0,0,1,6.415,4.966M29.2,14.116l.067-.4a9.761,9.761,0,0,1,18.086-3.226,1.225,1.225,0,0,0,1.658.461,4.987,4.987,0,0,1,2.436-.66,5.061,5.061,0,0,1,4.766,3.368l.163.458ZM65.12,21,63.386,22.73l5.676,5.676v7.519L65.12,31.983l-1.734,1.734,5.676,5.676v7.519L65.12,42.971,63.386,44.7l5.676,5.677v9.181l-.392-.056a11.332,11.332,0,0,1-9.712-11.2V13.772a11.331,11.331,0,0,1,22.661,0V48.3a11.332,11.332,0,0,1-9.712,11.2l-.393.056V50.382L77.191,44.7l-1.734-1.734-3.943,3.942V39.394l5.677-5.677-1.734-1.733-3.943,3.942V28.406l5.677-5.677L75.457,21l-5.169,5.168Z",
    transform: "translate(0 0)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.453,
    height: 3.753,
    transform: "translate(61.818 79.237) rotate(-45)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.453,
    height: 3.753,
    transform: "translate(85.362 80.806) rotate(-45)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.753,
    height: 2.453,
    transform: "translate(75.944 91.144) rotate(-45)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.452,
    height: 3.753,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 86.928, 90.223)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.753,
    height: 2.453,
    transform: "translate(58.678 91.144) rotate(-45)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.753,
    height: 2.453,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 53.969, 69.168)",
    fill: "#104864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlazaIcon);
export default __webpack_public_path__ + "static/media/PlazaIcon.a8a9a90d36f971ef6f82c1f1eed3122c.svg";
export { ForwardRef as ReactComponent };